export default __webpack_public_path__ + "static/media/blush-bright-winter.3cbde66e.png";